import React from 'react';
import { useSelector } from 'react-redux';
import styles from '@/views/components/SimpleTextAdivse/TopSection/TopSection.module.scss';

const TopSection = ({children, description, subTitle}) => {
	const dict = useSelector(state => state.app.dict);
	return (
		<>		
			<div className={ styles['advises__header'] }>
				<div className={ styles['advises__header__inner'] }>
					<h2 className={ styles['advises__header__title'] }>{dict.simpleTextAdvices.findAdvice.header}</h2>
					<div className={ styles['advises__header__divider'] } />
					<div className={ styles['advises__header__sub-title'] }>{subTitle}</div>
				</div>
				<div className={ styles['advises__description--mobile'] }>
					<p className={ styles['advises__description__text'] }>{description}</p>
				</div>
				<div className={ styles['advises__buttonsTop'] } >
					{children}
				</div>
			</div>
			<div className={ styles['advises__description'] }>
				<p className={ styles['advises__description__text'] }>{description}</p>
			</div>
		</>

	);
};

export default TopSection;